/**
 * Shared WalletConnect / AppKit configuration helpers.
 *
 * Kept in widget-host so both earn and tokenization widgets read the same env
 * var and agree on the baseline set of disabled AppKit features.
 */

/**
 * Returns the WalletConnect project ID from the Vite environment.
 * Both earn and tokenization widgets share the same project ID.
 */
export function getWalletConnectProjectId(): string | undefined {
  return import.meta.env.VITE_WALLETCONNECT_PROJECT_ID;
}

/**
 * AppKit feature flags that are disabled across all Blockdaemon widgets.
 * Spread this into `createAppKit({ features: { ...APPKIT_FEATURES_DISABLED, ... } })`
 * and add widget-specific overrides on top.
 */
export const APPKIT_FEATURES_DISABLED = {
  analytics: false,
  email: false,
  socials: false,
  onramp: false,
  swaps: false,
} as const;
